<template>
    <div class="contents" v-if="opened">
        <div class="scroll-height">
          <template v-if="!loading">
            <list-slot
                    v-for="type in types"
                    :key="type.id"
                    :main-text="type.name"
                    :sub-text="type.isValid ? type.description : type.unavailableMsg"
                    :disabled="!type.isValid"
                    :offers="offersForType(type)"
                    :selected="false"
                    v-on:click="setType(type)">
            </list-slot>
          </template>

          <template v-if="loading">
              <list-slot
                      v-for="n in placeholderCount"
                      :key="'typePlaceholder' + n"
                      :placeholder="true">
              </list-slot>
          </template>
        </div>
    </div>
</template>

<script>
  import BookingTypesProvider from '../services/BookingTypesProvider'
  import listSlot from './listSlot'
  import GoogleTagManagerService from '../services/GoogleTagManagerService'

  export default {
    name: 'typeStage',
    props: [
      'allowedTypes',
      'venue',
      'date',
      'pax',
      'value',
      'opened',
      'placeholderCount',
      'shouldShowOffers'
    ],
    data () {
      return {
        types: [],
        loading: true
      }
    },
    components: {
      listSlot
    },
    methods: {
      requestTypes () {
        this.loading = true
        this.types = []
        this.typeProvider.requestBookingTypes()
          .then((types) => {
            this.types = types
            this.filterAllowedTypes()
            this.filterLinkedTypes()
            this.filterHiddenTypes()

            this.gtmService.trackViewBookingTypes(
              this.types,
              this.venue.name
            )

            if (this.types.length === 1) {
              const currentType = this.$root.booking.type

              // Do not set the same booking type twice, prevents infinite loop
              if (!currentType || currentType.id !== this.types[0].id) {
                this.setType(this.types[0])
              }
            }

            this.loading = false
          })
      },
      setType (type) {
        if (type.isValid) {
          this.$emit('input', type)
        }
      },
      offersForType (type) {
        if (this.shouldShowOffers) {
          return type.offers
        }

        return []
      },
      filterAllowedTypes () {
        if (this.allowedTypes.length > 0) {
          this.types = this.types.filter((type) => {
            return this.allowedTypes.includes(type.id)
          })
        }
      },
      filterLinkedTypes () {
        if (!this.$root.dmnOptions.linkedBookingsEnabled) {
          this.types = this.types.filter(type => type.isLinkedType !== true)
        }
      },
      filterHiddenTypes () {
        if (this.$root.dmnOptions.linkedBookingsEnabled) {
          this.types = this.types.filter(type => type.hidden !== true)
        }
      }
    },
    mounted () {
      this.typeProvider = new BookingTypesProvider(this.$root.booking)
      this.gtmService = new GoogleTagManagerService()

      this.typeProvider.setUrlOptions({
        source: this.$root.dmnOptions.from
      })
    },
    watch: {
      // venue: function () {
      //   this.requestTypes()
      // },
      // pax: function () {
      //   this.requestTypes()
      // },
      // date: function () {
      //   this.requestTypes()
      // }
    }
  }
</script>



// WEBPACK FOOTER //
// typeStage.vue?7e9f028a